import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Link, useNavigate} from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
import Rightbar from './Rightbar';
import ImageUploading from 'react-images-uploading';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSelector} from 'react-redux';
import { createEventExhibitorProfile, getEventExhibitorProfile } from '../../Service';
import { useParams } from "react-router";

export default function CreateProfile() {
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
    const maxNumber = 69;
      // Mycode for ref
    const navigation = useNavigate();
    let loggedUser = useSelector(store => store.user['user']);
    let user_id = '';
    if(loggedUser){
        user_id = loggedUser.id;    
    }
    const [list, setList] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState([]);
    const { id } = useParams();
    const event_id  = id;
    
    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
        const field1='profile_image';
        setFormValues(prevState => ({
            ...prevState,
            [field1]:  imageList[0]['file']
        }));
    };
      

    useEffect(() => {
        let paramsData={user_id:user_id,event_id:event_id};
        console.log('poiuyt',paramsData);
        getEventExhibitorProfile(paramsData).then(res => setHandleExhibitorResponse(res))
    },[]);

    

    const setHandleExhibitorResponse = (res) => 
    {
        console.log('res 56', res.data.data)
        if(res.data.data)
        {
            setList(res.data.data );
            setFormValues(res.data.data)
        }
        
    }


    const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
        ...prevState,
        [field]: value }));
        
        }

    
    const handleSubmit = (e) => {
        e.preventDefault();
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        console.log(errorCount)
        console.log(errorCount)
        if(errorCount.status){
        var bodyFormData = new FormData();
        bodyFormData.append('name', formValues.name ? formValues.name : loggedUser.name);
        bodyFormData.append('address1', formValues.address1 ? formValues.address1 : loggedUser.address1);
        bodyFormData.append('address2', formValues.address2 ? formValues.address2 : loggedUser.address2);
        bodyFormData.append('city', formValues.city ? formValues.city : loggedUser.city);
        bodyFormData.append('state', formValues.state ? formValues.state : loggedUser.state);
        bodyFormData.append('country', formValues.country ? formValues.country : loggedUser.country);
        bodyFormData.append('phone', formValues.phone ? formValues.phone : loggedUser.phone);
        bodyFormData.append('website', formValues.website ? formValues.website : loggedUser.website);
        bodyFormData.append('primary_contact_full_name', formValues.primary_contact_full_name ? formValues.primary_contact_full_name : loggedUser.primary_contact_full_name);
        bodyFormData.append('instagram', formValues.instagram ? formValues.instagram : loggedUser.instagram);
        bodyFormData.append('twitter', formValues.twitter ? formValues.twitter : loggedUser.twitter);
        bodyFormData.append('facebook', formValues.facebook ? formValues.facebook : loggedUser.facebook);
        bodyFormData.append('email', loggedUser.email);
        bodyFormData.append('billing_email', formValues.billing_email ? formValues.billing_email : loggedUser.email);
        bodyFormData.append('gallery_history', formValues.gallery_history ? formValues.gallery_history : loggedUser.gallery_history);
        bodyFormData.append('profile_image', loggedUser.profile_image);
        bodyFormData.append('profile_image_path', loggedUser.profile_image_path);
        bodyFormData.append('user_id', user_id);
        bodyFormData.append('event_id', event_id);
        createEventExhibitorProfile(bodyFormData).then(res => handleResponse(res))
        }
    }

    const handleResponse = (response) => {
        console.log("response 82",response.data.code)
        if(response.data.code==400)
        {
            alert(response.data.message);
            window.scrollTo(0, 0);
        }
        else if(response.status==200)
        {
            navigation("/boothDetails/"+event_id);
            window.scrollTo(0, 0);
        }
        
        else
        {
            
            navigation('/createProfile/'+event_id);
            window.scrollTo(0, 0);
        }
    }

    const handleBackSubmit =(e) => {
        navigation('/eventapplication/'+event_id);
        window.scrollTo(0, 0);
    }


    const validate = (values) => 
    {
        
        const errors = {};
        errors.status = true;
        var error_val=0;
        
        if(!values.name || values.name == null){
            if(!loggedUser.name){
            errors.name = 'Please Enter the name';
            error_val = 1;
            }
        }

        if(!values.address1){
            if(!loggedUser.address1){
            errors.address1 = 'Please Enter the Address';
            error_val = 1;
            }
        }

        if(!values.city){
            if(!loggedUser.city){
            errors.city = 'Please Enter the city';
            error_val = 1;
            }
        }

        if(!values.state){
            if(!loggedUser.state){
            errors.state = 'Please Enter the state';
            error_val = 1;
            }
        }

        if(!values.country){
            if(!loggedUser.country){
            errors.country = 'Please Enter the country';
            error_val = 1;
            }
        }

        if(!values.phone){
            if(!loggedUser.phone){
            errors.phone = 'Please Enter the phone';
            error_val = 1;
            }
        }

        if(!values.primary_contact_full_name){
            if(!loggedUser.primary_contact_full_name){
            errors.primary_contact_full_name = 'Please Enter the primary contact name';
            error_val = 1;
            }
        }

        // if(!values.email){
        //     errors.email = 'Please Enter the email';
        //     error_val = 1;
        // }

        if(!values.billing_email){
            if(!loggedUser.email){
            errors.billing_email = 'Please Enter the billing email';
            error_val = 1;
            }
        }

        if(!values.gallery_history){
            if(!loggedUser.gallery_history){
            errors.gallery_history = 'Please Enter the gallery history';
            error_val = 1;
            }
        }

        // if(images.length===0){
        //     if(!loggedUser.profile_image){
        //     errors.images = 'Image is required';
        //     error_val = 1;
        //     }
        // }
        
        
        if(error_val===1)
        {
            errors.status=false;
        }
        else
        {
            errors.status=true;
        }
        return errors;
    }

    //console.log('log 198', formValues.name)
    //console.log('log 199', typeof formValues.name!='undefined'  ? formValues.name : loggedUser.name )
    
    return(
    <>
        <section className="sec-container" >
            <div className='container'>
                <div className='portalevent'>
                    <div className='row'>
                        <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                            <div >
                                <Rightbar event_id={event_id}/> 
                            </div>
                        </div>
                        <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                            <div className='rightbar '>
                                <Button variant="outline-info" onClick={toggle}>
                                    <FontAwesomeIcon icon={faAlignLeft} />
                                </Button>
                                <h1>CREATE EXHIBITOR PROFILE</h1>
                                <Form> 
                                    <Form.Group>
                                        <Form.Label>Gallery Name <span className='star'>*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Gallery Name" name="name" value={typeof formValues.name!='undefined'  ? formValues.name : loggedUser.name }  onChange={hanldeChange} />
                                        <p className="error">{formErrors.name}</p>
                                    </Form.Group>
                                    
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Address <span className='star'>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Street Address" name="address1" value={typeof formValues.address1!='undefined'  ? formValues.address1 : loggedUser.address1 } onChange={hanldeChange} />
                                                <p className="error">{formErrors.address1}</p>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Address 2 </Form.Label>
                                                <Form.Control type="text" placeholder="Apt, Suite, Etc..." name="address2" value={typeof formValues.address2!='undefined'  ? formValues.address2 : loggedUser.address2 } onChange={hanldeChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>City <span className='star'>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="City" name="city" 
                                                value={typeof formValues.city!='undefined'  ? formValues.city : loggedUser.city } onChange={hanldeChange} />
                                                <p className="error">{formErrors.city}</p>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>State <span className='star'>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="State" name="state" 
                                                value={typeof formValues.state!='undefined'  ? formValues.state : loggedUser.state } onChange={hanldeChange} />
                                                <p className="error">{formErrors.state}</p>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Country<span className='star'>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Country" name="country" value={typeof formValues.country!='undefined'  ? formValues.country : loggedUser.country }  onChange={hanldeChange} />
                                                <p className="error">{formErrors.country}</p>
                                            </Form.Group>
                                        </Col>
                                    </Row>
            
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Phone Number<span className='star'>*</span></Form.Label>
                                                <Form.Control type="number" placeholder="Phone Number" name="phone" value={typeof formValues.phone!='undefined'  ? formValues.phone : loggedUser.phone } onChange={hanldeChange} />
                                                <p className="error">{formErrors.phone}</p>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Website </Form.Label>
                                                <Form.Control type="text" placeholder="Website" name="website" value={typeof formValues.website!='undefined'  ? formValues.website : loggedUser.website } onChange={hanldeChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Primary Contact Full Name<span className='star'>*</span></Form.Label>
                                                <Form.Control type="text" placeholder="Primary Contact Full Name" name="primary_contact_full_name" value={typeof formValues.primary_contact_full_name!='undefined'  ? formValues.primary_contact_full_name : loggedUser.primary_contact_full_name } onChange={hanldeChange} />
                                                <p className="error">{formErrors.primary_contact_full_name}</p>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Instagram Handle </Form.Label>
                                                <Form.Control type="text" placeholder="@Instagram" name="instagram" value={typeof formValues.instagram!='undefined'  ? formValues.instagram : loggedUser.instagram } onChange={hanldeChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Twitter Handle</Form.Label>
                                                <Form.Control type="text" placeholder="@Twitter"  name="twitter" value={typeof formValues.twitter!='undefined'  ? formValues.twitter : loggedUser.twitter } onChange={hanldeChange}/>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Facebook</Form.Label>
                                                <Form.Control type="text" placeholder="Facebook"  name="facebook" value={typeof formValues.facebook!='undefined'  ? formValues.facebook : loggedUser.facebook } onChange={hanldeChange}/>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {/* <Form.Group>
                                        <Form.Label>Email <span className='star'>*</span></Form.Label>
                                        <Form.Control type="email" placeholder="Email" name="email" defaultValue={formValues.email}  onChange={hanldeChange}  aria-label="Disabled input example" readOnly />
                                        <p className="error">{formErrors.email}</p>
                                    </Form.Group> */}

                                    <Form.Group>
                                        <Form.Label>Billing Email <span className='star'>*</span></Form.Label>
                                        <Form.Control type="email" placeholder="Billing Email" name="billing_email" value={typeof formValues.billing_email!='undefined'  ? formValues.billing_email : loggedUser.email }  onChange={hanldeChange}   />
                                        <p className="error">{formErrors.billing_email}</p>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Describe the history of your gallery <span className='star'>*</span></Form.Label>
                                        <Form.Control as="textarea" rows={3} placeholder="Gallery History" name="gallery_history" value={typeof formValues.gallery_history!='undefined'  ? formValues.gallery_history : loggedUser.gallery_history } onChange={hanldeChange} />
                                        <p className="error">{formErrors.gallery_history}</p>
                                    </Form.Group>

                                    {/* <Form.Group>
                                        <Form.Label>Profile Image <span className='star'>*</span></Form.Label>
                                        <p>
                                            <i>This image will represent your gallery on the fair landing page. 
                                            Images will be cropped to 3:2 (4x6) aspect ratio</i>
                                        </p>
                                        <p>
                                            File Specifications: jpg, sRGB, 72 dpi, less than or equal to 2MB
                                            File names cannot contain any apostrophes or special characters .
                                        </p>
                                        <p className="error">{formErrors.images}</p>
                                        <ImageUploading value={images} onChange={onChange} maxNumber={maxNumber} dataURLKey="data_url">
                                        {({
                                        imageList,
                                        onImageUpload,
                                        onImageRemoveAll,
                                        onImageUpdate,
                                        onImageRemove,
                                        isDragging,
                                        dragProps,
                                        }) => (
                                        // write your building UI
                                        <div className="choose-file">
                                            <button type='button' style={isDragging ? { color: 'red' } : undefined} onClick={onImageUpload}
                                            {...dragProps}
                                            >
                                                <img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
                                                
                                            </button>
                                            <br/><br/>
                                                { formValues.profile_image ? 
                                                <img src={process.env.REACT_APP_API_STORAGE+formValues.profile_image_path}/>
                                                :
                                                ""
                                                }
                                               
                                            <p>File Specifications: jpg, sRGB, 2MB note: images will be cropped as square</p>
                                            { imageList.map((image, index) => (
                                                <div key={index} className="image-item">
                                                    <img src={image['data_url']} alt="" width="100" />
                                                    <div className="image-item__btn-wrapper">
                                                     
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                        )}
                                        </ImageUploading>
                                    </Form.Group> */}

                                <Form.Group>
                                <div class="choose-file"> 
                                     {loggedUser.profile_image_path ? <img src={process.env.REACT_APP_API_STORAGE+loggedUser.profile_image_path}/> : ''}
                                </div>
                                </Form.Group>

                                    <hr/>
                                    <div className='text-center'>
                                        <Button variant="submit"  onClick={handleSubmit} className='common-btn'>Next</Button>{' '}
                                        <Button variant="outline-secondary" onClick={handleBackSubmit} className='cancel-btn'>Back</Button>{' '}
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
    )
}